<template>
  <div>
    <el-popover
      placement="bottom"
      width="400"
      trigger="click"
      @show="()=>disableBtn=true"
      @hide="()=>disableBtn=false">
      <div>
        <loading-panel v-if="loading"/>
        <div v-if="details" class="striped">
          <p>{{ details.from | dateOnly }} - {{ details.to | dateOnly }} <span
            class="lighter smaller">({{ details.generated_at | time }})</span></p>
          <p>{{ $t('accountCapLimit.details.supported_cap_names.' + details.cap_name) }} - {{ details.discount_id }}
          </p>

          <p v-for="value in details.caps" :key="value.fare_group_id" class="border-top border-primary">
            <table class="striped_table w-100">
              <th>
                <td colspan="2">{{ value.fare_group_id }}</td>
              </th>
              <tr class="p-0 m-0">
                <td class="p-0 pr-1 m-0 font-weight-light border-right">{{
                    $t('accountCapLimit.details.municipality_id')
                  }}
                </td>
                <td class="pl-1 m-0">{{ value.municipality_id }}</td>
              </tr>
              <tr class="p-0 m-0">
                <td class="p-0 pr-1 m-0 font-weight-light border-right">{{
                    $t('accountCapLimit.details.cap_price')
                  }}
                </td>
                <td class="pl-1 m-0">{{ value.cap_price | money }}</td>
              </tr>
              <tr class="p-0 m-0">
                <td class="p-0 pr-1 m-0 font-weight-light border-right">{{
                    $t('accountCapLimit.details.single_price')
                  }}
                </td>
                <td class="pl-1 m-0">{{ value.single_price | money }}</td>
              </tr>
              <tr class="p-0 m-0">
                <td class="p-0 pr-1 m-0 font-weight-light border-right">{{
                    $t('accountCapLimit.details.savings')
                  }}
                </td>
                <td class="pl-1 m-0">{{ value.savings | money }}</td>
              </tr>
            </table>
          </p>
        </div>
      </div>

      <el-tooltip v-if="$auth.can({account_journey: 'read'}, 'permissions')"
                  slot="reference" :content="$t('accountCapLimit.btnTooltip')"
                  effect="light"
                  :open-delay="300"
                  placement="bottom">
        <base-button icon round type="neutral" @click.prevent="load()" class="text-nowrap zi_100"
                     :disabled="disableBtn">
          <span class="mdi mdi_icon mdi-24px mdi-piggy-bank-outline"/>
        </base-button>
      </el-tooltip>
    </el-popover>
  </div>
</template>


<script>
import {mapActions, mapState} from "vuex";
import {Popover} from 'element-ui'
import LoadingPanel from "src/components/LoadingPanel";

export default {
  name: 'load-account-cap-limit-btn',
  components: {
    [Popover.name]: Popover,
    LoadingPanel
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      disableBtn: false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.account_cap_limit.loading,
      error: state => state.account_cap_limit.error,
      details: state => state.account_cap_limit.data,
    }),
  },
  methods: {
    ...mapActions(['GetAccountCapLimit']),
    load() {
      this.GetAccountCapLimit({accountId: this.accountId})
    },
  }
}
</script>

<style scoped>

.lighter {
  font-weight: lighter;
}
</style>
